































































import { Component, Vue, Prop, Watch } from "@/shared/vuepack";
import VueRouter, { Location } from "vue-router";
import FileUpload from "vue-upload-component";
import { DrivewealthLiquidationFileUploadStatus } from "@/shared/types";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import Pagination from "@/shared/components/ui/Pagination.vue";
import { useNotifierStore } from "@/shared/store/notifier";
import { useBulkLiquidationStore } from "@/employer/store/bulkLiquidation";
import moment from "moment/moment";
import { downloadBulkLiquidationStatus } from "@/shared/api/drivewealthService";


@Component({
  components: {
    FileUpload,
    GenericLoadingSpinner,
    Pagination
  }
})

export default class BulkLiquidationManagement extends Vue {
  $router: VueRouter;
  DrivewealthLiquidationFileUploadStatus = DrivewealthLiquidationFileUploadStatus;
  file = null;
  isSubmitting = false;
  bulkLiquidationStore = useBulkLiquidationStore();
  notifierStore = useNotifierStore();

  @Prop()
  page: number;

  @Prop()
  partnerId: number;

  @Prop()
  routeToBulkLiquidationManagement: (partnerId: number, pageNumber: number) => Location;

  mounted (): void {
    this.load();
  }

  load (): void {
    this.bulkLiquidationStore.getUploads({page: this.page, partnerId: this.partnerId});
  }

  get uploadTableFields (): { key: string, label: string }[] {
    return [
      { key: "fileName", label: "Original File Name" },
      { key: "fileNameGuid", label: "File Name Guid" },
      { key: "dateCreated", label: "Date Created" },
      { key: "uploadStatus", label: "Status" },
      { key: "recordCount", label: "Record Count" },
      { key: "downloadUrl", label: "Results" }
    ];
  }

  get submitDisabled (): boolean {
    return this.isSubmitting || this.bulkLiquidationStore.isUploadingFile;
  }

  fileChange (file): void {
    if (!file) return;
    this.file = (document.getElementById("file-asset") as any).files[0];
  }

  get fileNameDisplay (): string {
    return this.file ? this.file.name : "Click to select .csv file";
  }

  get pageTotal (): number {
    return this.bulkLiquidationStore.pageTotal(this.page);
  }

  get pageLoaded (): boolean {
    return this.bulkLiquidationStore.isPageLoaded(this.page);
  }

  get uploadItems () {
    const uploads = this.bulkLiquidationStore.pagedUploadsById(this.page);

    if (uploads) {
      return uploads.map(d => ({
        fileName: d.fileName,
        fileNameGuid: d.fileNameGuid,
        dateCreated: moment(d.dateCreated).format("MMMM D, YYYY"),
        uploadStatus: d.uploadStatus,
        recordCount: d.recordCount,
        downloadUrl: d.downloadUrl
      }));
    }

    return uploads;
  }

  submit (): void {
    if (!this.file) return;
    if (this.isSubmitting) return;

    this.isSubmitting = true;

    this.bulkLiquidationStore.uploadBulkLiquidationFile({
      partnerId: this.partnerId,
      file: this.file
    })
    .then(() => {
      this.bulkLiquidationStore.resetUploadsState();
    })
    .catch(() => null)
    .finally(() => {
      this.isSubmitting = false;
      this.file = null;
      this.load();
    });
  }

  downloadBulkLiquidationStatus (event, fileNameGuid: string): void {
    event.preventDefault();
    const partnerId = this.partnerId;
    this.bulkLiquidationStore.downloadBulkLiquidationStatus({ partnerId, fileNameGuid });
  }

  onPageChanged (page: number): void {
    this.$router.push(this.routeToBulkLiquidationManagement(this.partnerId, page));
  }

  @Watch("page")
  onRouteValuePageNumberChanged () {
    this.load();
  }
}
